import { styled } from "styled-components";

import { colourScheme } from "utils/styling/colours";

import { CheckboxType } from "./types";

const getVariantColours = (variant?: CheckboxType): [string, string] => {
    switch (variant) {
        case CheckboxType.ERROR:
            return [colourScheme.error, colourScheme.fullWhite];
        default:
            return [colourScheme.primary, colourScheme.fullWhite];
    }
};

export const CheckboxInput = styled.input<{ $variant?: CheckboxType }>`
    position: absolute;
    top: 2rem;
    left: 2rem;
    width: 2rem;
    height: 2rem;
    z-index: 2;
    cursor: pointer;
    opacity: 0;

    & + label::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
        background: ${(props) => getVariantColours(props.$variant)[1]};
        display: inline-block;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    & + label::after {
        content: "✔";
        position: absolute;
        top: 0rem;
        left: 0rem;
        width: 2rem;
        height: 2rem;
        border-radius: 0.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 1.5rem;
        opacity: 0;
        transition: opacity 0.3s ease;
    }

    &:hover + label::before,
    &.visible + label::before {
        opacity: 1;
    }

    &:checked + label::before {
        background: ${(props) => getVariantColours(props.$variant)[0]};
    }

    &:checked + label::after {
        opacity: 1;
    }

    & + label {
        position: absolute;
        top: 1.5rem;
        left: 2.5rem;
        width: 2rem;
        height: 2rem;
        cursor: pointer;
    }
`;
